// export const environment = {
//     apiUrl: 'https://apidev2.digicoffer.com/professional',
//     apiUrlHealth:'https://healthcare.adminapi.digicoffer.com',
//     queryUrl: 'https://adminapi.dev2.digicoffer.com',
//     doc2pdf:"https://dev.utils.doc2pdf.digicoffer.com/api/v1/doc2pdf",
//     DOC2FILE :'https://dev.utils.doc2pdf.digicoffer.com/api/v1/docfile2pdf',
//     product: 'admin_console',
//     production: false
// };
export const environment = {
    apiUrl: 'https://apidev2.digicoffer.com/professional',
    apiUrlHealth:'https://healthcare.adminapi.digicoffer.com',
    regswatchApiUrl: 'https://adminapi.regswatch.com',
    queryUrl: 'https://adminapi.dev2.digicoffer.com',
    doc2pdf:"https://prod.utils.doc2pdf.digicoffer.com/api/v1/doc2pdf",
    DOC2FILE :'https://prod.utils.doc2pdf.digicoffer.com/api/v1/docfile2pdf',
    product: 'admin_console',
    production: false
};